/*
Auto-select the pre-selected shoe/belt size for the user in the collection template or on search.
When selecting a new size, update the pre-selected size.
*/

document.addEventListener("DOMContentLoaded", function () {
	// Auto-select stored size when popup opens
	document.body.addEventListener("click", function (e) {
		const selectBtn = e.target.closest(".boost-sd__button--select-option");
		
		if (selectBtn) {

				// Find the visible popup
				const popup = document.querySelector(
					'.boost-sd__popup-select-option[style*="display: block"]'
				);
				if (!popup) return;

				popup
					.querySelectorAll(".boost-sd__radio-input")
					.forEach(function (input) {
						const label = popup.querySelector(
							'.boost-sd__radio-label[for="' + input.id + '"]'
						);

						if (!label) return;
						const type = label.getAttribute("aria-label") || "";

						if (type.includes("shoe")) {
							const storedShoe =
								localStorage.getItem("userShoeSize");
							if (storedShoe && input.value === storedShoe) {

									input.click();

							}
						} else if (type.includes("belt")) {
							const storedBelt =
								localStorage.getItem("userBeltSize");
							if (storedBelt && input.value === storedBelt) {

									input.click();

							}
						}
					});

		}
	});

	// Store selected size in localStorage when user picks a size
	document.body.addEventListener("click", function (e) {
		const label = e.target.closest(".boost-sd__radio-label");
		if (label) {
			const type = label.getAttribute("aria-label") || "";
			const inputId = label.getAttribute("for");
			const input = document.getElementById(inputId);
			if (input && input.value && type) {
				if (type.includes("shoe")) {
					localStorage.setItem("userShoeSize", input.value);
				} else if (type.includes("belt")) {
					localStorage.setItem("userBeltSize", input.value);
				}
			}
		}
	});
});
